import { useSelector } from 'react-redux';

import { selectProductsRating, selectRatingSravni, selectServicesRating } from '../selectors/ratings';

import { useAppSelector } from './redux';

export const useRatingSravni = () => useSelector(selectRatingSravni);
export const useServicesRating = () => useAppSelector(selectServicesRating);
export const useProductsRating = (id: string) => useAppSelector(selectProductsRating(id));
